import React from 'react';
import moment from 'moment';

import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import VehicleSelect from '../Select/Vehicle';

import { withRouter } from 'react-router-dom';

const TemperatureFilter = ({ onSubmit, location, defaultInterval }) => {

    const params = new URLSearchParams(location.search);
    const vehicle_id = params.get('vehicle_id');

    const filter = e => {
        e.preventDefault();

        onSubmit({
            start: document.getElementById('start').value,
            end: document.getElementById('end').value,
            interval: document.getElementById('interval').value,
            vehicle_id: document.getElementById('vehicle_id').value
        });
    }

    return (
        <Paper>
            <form onSubmit={filter}>
                <div className="form-item">
                    <TextField
                        id="start"
                        label="Inicio"
                        type="datetime-local"
                        required
                        defaultValue={moment().format('YYYY-MM-DDT06:00')}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        fullWidth
                    />
                </div>

                <div className="form-item">
                    <TextField
                        id="end"
                        label="Fim"
                        type="datetime-local"
                        required
                        defaultValue={moment().format('YYYY-MM-DDT18:00')}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        fullWidth
                    />
                </div>

                <div className="form-item">
                    <TextField
                        id="interval"
                        label="Intervalo em minutos"
                        type="number"
                        required
                        defaultValue={defaultInterval}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ min: 1 }}
                        margin="normal"
                        fullWidth
                    />

                </div>

                <div className="form-item" style={{minWidth: '200px'}}>
                    <label className="label">Veículo</label>
                    <VehicleSelect defaultValue={vehicle_id} />
                </div>

                <div className="form-item">
                    <Button type="submit" raised color="primary" style={{width: '100%', marginTop: '16px'}}>
                        Consultar
                    </Button>
                </div>
            </form>
        </Paper>
    );

}

export default withRouter(TemperatureFilter);



// WEBPACK FOOTER //
// ./src/components/Temperature/Filter.js